<template>
  <div class="column is-4 flex flex-vertical-center flex-between motivator_item" :class="{'is-true': value}">
    <p>{{ label }}</p>
    <p>{{ value ? 'Yes' : 'No' }}</p>
  </div>
</template>

<script>
export default {
  name: "HotMotivatorItem",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: Boolean,
      required: true,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.motivator_item {
  padding-top: 0;
  padding-bottom: 0;
  line-height: 2;

  &.is-true {
    color: $success;
    font-weight: bold;
  }
}
</style>
